<template>
  <!-- 在线设备 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 设备编码 -->
        <el-form-item :label="$t('pages.research.text73')">
          <el-input
            v-model="searchParams.devCode"
            placeholder=""
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.research.text82')">
          <!-- 在线状态 -->
          <el-select v-model="searchParams.status" clearable placeholder="">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 上报时间 -->
        <el-form-item :label="$t('pages.research.text83')">
          <el-date-picker
            v-model="startAt"
            type="datetime"
            :picker-options="pickerOptions0"
            :placeholder="$t('public.text2')"
            @change="startChange"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮区域 -->
    <div class="searchSubmit">
      <DiluButton
        type="search"
        @click="search"
        v-permission="['logDefend:query']"
      ></DiluButton>
      <DiluButton
        type="reset"
        @click="reset"
        v-permission="['logDefend:reset']"
      ></DiluButton>
    </div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column
        prop="devCode"
        :label="$t('pages.research.text73')"
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="onlineStatus"
        :label="$t('pages.research.text82')"
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="lastReport"
        :label="$t('pages.research.text84')"
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="showDetail(scope.row)"
              type="text"
              size="small"
              >{{ $t("pages.research.text85") }}</el-button
            >
            <el-button @click="sendCmd(scope.row)" type="text" size="small">{{
              $t("pages.research.text86")
            }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 设备详情弹窗 -->
    <el-dialog
      :title="$t('pages.research.text85')"
      :visible.sync="detailVisible"
      width="600px"
      padding-top="10px"
    >
      <JsonView :json="jsonData"></JsonView>
    </el-dialog>

    <!-- 发送指令弹窗 -->
    <SendInstructions
      :cmdVisible="cmdVisible"
      :downParams="downParams"
      @dialogClose="dialogClose"
    />
  </div>
</template>

<script>
import SendInstructions from "./module/sendInstructions";
import JsonView from "./module/jsonView";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import { resetDate } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      //选中的开始日期之前的日期禁选
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        devCode: "", //设备编码
        lastTime: "", //上报时间
        status: "10", //在线状态
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      },
      downParams: {
        passwd: "", //授权代码
        devCode: "", //设备编码
        cType: "", //报文指令
        lockCtrl: "",
        lockType: "",
        lightType: "",
        speed: "25",
        mode: "",
        flashTime: "",
        audioTimes: "",
        host: "",
        port: "",
        userName: "",
        password: "",
        path: "",
        audioSwitch: "",
        audioFile: "",
        repeatTime: "",
        switchOption: "",
        fileName: "",
        apn: "",
        bleName: "",
        heartbeat: "",
        unlockInterval: "",
        lockInverval: "",
        automaticLock: "",
        vibration: "",
        alarmToneTimes: "",
        chainBleMAC: "",
        chainBleKey: "",
        batteryBleMAC: "",
        batteryBleKey: "",
      },
      startAt: "", //开始日期时间
      stopAt: "", //结束日期时间
      options: [
        { value: "10", label: this.$t("pages.equipment.text132") },
        { value: "20", label: this.$t("pages.operate.text10") },
      ],
      tableConfig: {
        isTree: false,
        isPage: true, //打开分页功能
      },
      total: 0,
      detailVisible: false, //详情弹窗
      cmdVisible: false, //指令详情
      jsonData: {},
      tableData: [],
    };
  },
  components: {
    DiluTable,
    DiluButton,
    JsonView,
    SendInstructions,
  },
  mounted() {
    this.queryList();
  },
  methods: {
    //搜索
    search() {
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.queryList();
    },
    //更改开始日期时间时结束日期时间置空重选
    startChange() {
      this.stopAt = "";
    },
    // 关闭下发指令弹窗
    dialogClose() {
      this.cmdVisible = false;
    },
    //在线设备列表
    queryList() {
      if (this.stopAt && this.startAt) {
        this.stopAt = resetDate(this.stopAt); // 结束时间
        this.startAt = resetDate(this.startAt); // 开始时间
        this.searchParams.lastTime = [this.startAt, this.stopAt];
      } else {
        this.searchParams.lastTime = "";
      }
      if (this.startAt) {
        if (!this.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.stopAt) {
        if (!this.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.request.queryList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //重置
    reset() {
      this.searchParams = {
        devCode: "", //设备编码
        lastTime: "", //上报时间
        status: "", //在线状态
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      };
      (this.startAt = ""), //选择的开始日期
        (this.stopAt = ""), //选择的结束日期
        (this.total = 0);
      this.queryList();
    },
    //显示设备详情
    showDetail(e) {
      this.request.devInfo({ devCode: e.devCode }).then((res) => {
        if (res.code == 0) {
          this.jsonData = res.data;
          this.detailVisible = true;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //发送指令
    sendCmd(e) {
      if (e.onlineStatus == "Offline") {
        this.$message({
          type: "error",
          message: this.$t("pages.research.text87"),
        });
      } else {
        this.downParams.devCode = e.devCode;
        this.cmdVisible = true;
      }
    },
    //翻页
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.queryList();
    },
  },
};
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
}
.searchSubmit {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
}
</style>